import { notNull } from "@/utils/helpers";
import { z } from "zod";

export const qualityScoreReasonEnum = z
  .enum([
    "suspect_ai_answers",
    "misrepresentation",
    "bad_video",
    "bad_audio",
    "short_answers",
    "straightlining",
    "other",
  ])
  .describe(
    "The reason for the quality score. Required when category is 'low' or 'fraud'."
  );
export const categoryEnum = z.enum([
  "excellent",
  "good",
  "average",
  "low",
  "fraud",
]);
const evidenceCitation = z.object({
  message_index: z
    .number()
    .min(0)
    .describe(
      "The index of the message in the conversation that is the evidence for the quality score"
    ),
  quotation_start: z
    .number()
    .min(0)
    .describe(
      "The start index of the quotation in the message, zero-indexed from the start of the message and inclusive"
    ),
  quotation_end: z
    .number()
    .min(0)
    .describe(
      "The end index of the quotation in the message, zero-indexed from the start of the message and exclusive"
    ),
  description: z
    .string()
    .describe(
      "The description of why this quotation supports the quality score"
    ),
});

export const evidenceCitationArray = z
  .array(evidenceCitation)
  .describe(
    "The evidence for the quality score. PROVIDE AT MOST 3 EVIDENCE CITATIONS. NOT MORE."
  );

export const qualityScoreSchema = z
  .object({
    reasoning: z.string().describe("Explanation of the quality assessment"),
    category: categoryEnum.describe("The overall quality category"),
    evidence: evidenceCitationArray,
    confidence: z
      .number()
      .min(0)
      .max(1)
      .describe("Confidence score between 0 and 1"),
    reason: qualityScoreReasonEnum
      .nullish()
      .describe(
        "The reason for low quality or fraud. Required when category is 'low' or 'fraud', should be null otherwise."
      ),
  })
  .refine(
    (data) => {
      if (data.category === "low" || data.category === "fraud") {
        return notNull(data.reason);
      }
      return true;
    },
    {
      message: "Reason is required when category is 'low' or 'fraud'",
    }
  );
